import { render, staticRenderFns } from "./buLu.vue?vue&type=template&id=5c4cb46e&scoped=true&"
import script from "./buLu.vue?vue&type=script&lang=js&"
export * from "./buLu.vue?vue&type=script&lang=js&"
import style0 from "./buLu.vue?vue&type=style&index=0&id=5c4cb46e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4cb46e",
  null
  
)

export default component.exports